$shm_hitalama_vk_lists_editing $shm_hitalama_vk_lists_creating
	title \Редактирование списка
	param \edit
	list $shm_hitalama_vk_list
